import { RouterType } from '@online-webinar/router';
import { WebinarAnalytics } from '@online-webinar/webinar-management';
import { authGuard } from '../integrations/auth-guard';

export const updateRoute = (router: RouterType) => {
    router.routesById['/$webinarId/analytics'].update({
        staticData: { title: { page: 'Title.Analytics', forWebinar: true } },
        component: authGuard(WebinarAnalytics, { canBroadcast: true })
    });
};
